import React, { useState, useEffect } from 'react'
import { Form, Input, Button, Toast } from 'antd-mobile'
import { validateIDNumber } from '@bihu/common-js'
import styles from './identity-info-modal.module.scss'
import close from '@imgs/information/close3.png'
import successImg from '@imgs/information/success-img.png'
import classNames from 'classnames'

interface IdentityInfoModalProps {
  visible: boolean
  onClose: () => void
  onSubmit: (data: { name: string; idCard: string }) => void
  maxAmount?: number

}

interface NotificationItem {
  name: string
  amount: number
  time: string
}

const IdentityInfoModal: React.FC<IdentityInfoModalProps> = ({
  visible,
  onClose,
  onSubmit,
  maxAmount = 140000
}) => {
  const [form] = Form.useForm()
  const [currentNotificationIndex, setCurrentNotificationIndex] = useState(0)
  const [loading, setLoading] = useState(false)
  // 选择协议
  // const [checked, setChecked] = useState(false)
  // 是否抖动
  // const [isShake, setIsShake] = useState(false)
  // 协议弹窗
  // const [showAgreementModal, setShowAgreementModal] = useState(false)

  // 随机姓氏列表
  const surnames = ['张', '李', '王', '刘', '陈', '杨', '赵', '黄', '周', '吴', '徐', '孙', '胡', '朱', '高', '林', '何', '郭', '马', '罗']

  // 生成随机通知数据
  const generateNotifications = (): NotificationItem[] => {
    const notifications: NotificationItem[] = []
    for (let i = 0; i < 10; i++) {
      const randomSurname = surnames[Math.floor(Math.random() * surnames.length)]
      // 生成3万到20万的整万数
      const randomAmount = (Math.floor(Math.random() * (20 - 3 + 1)) + 3) * 10000
      const randomMinutes = Math.floor(Math.random() * 60) + 1
      notifications.push({
        name: `${randomSurname}**`,
        amount: randomAmount,
        time: `${randomMinutes}分钟前`
      })
    }
    return notifications
  }

  const [notifications] = useState<NotificationItem[]>(generateNotifications())

  // 轮播效果
  useEffect(() => {
    if (!visible) {
      return
    }

    const interval = setInterval(() => {
      setCurrentNotificationIndex(prev => (prev + 1) % notifications.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [visible, notifications.length])

  // 重置弹窗状态
  useEffect(() => {
    if (visible) {
      setCurrentNotificationIndex(0)
      form.resetFields()
    }
  }, [visible, form])

  // 切换选中协议
  // const checkedTaggle = () => {
  //   setChecked(!checked)
  // }
  // 身份证号验证
  const validateIdCard = (value: string) => {
    if (!value) {
      Toast.show('请输入您的身份证号')
      return
      // return Promise.reject(new Error('请输入您的身份证号'))
    }
    if (!validateIDNumber(value)) {
      Toast.show('请输⼊正确身份证号')
      return
      // return Promise.reject(new Error('请输⼊正确身份证号'))
    }
    return Promise.resolve()
  }

  // 姓名验证
  const validateName = (value: string) => {
    if (!value) {
      Toast.show('请输⼊您的姓名')
      return
      // return Promise.reject(new Error('请输入您的姓名'))
    }
    // if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
    //   return Promise.reject(new Error('姓名不能含有非中文字符'))
    // }
    return Promise.resolve()
  }

  // 提交处理
  const handleSubmit = async(skipCheck = false) => {
    try {
      const values = await form.validateFields()

      // 校验姓名
      if (!values.name) {
        return Toast.show('请输入您的姓名')
      }
      if (!/^[\u4e00-\u9fa5]+$/.test(values.name)) {
        return Toast.show('姓名不能含有非中文字符')
      }

      // 校验身份证号
      if (!values.idCard) {
        return Toast.show('请输入身份证号')
      }
      if (!validateIDNumber(values.idCard)) {
        return Toast.show('身份证号不正确，请重新输入')
      }

      // 未勾选协议则弹窗提示
      // if (!checked && !skipCheck) {
      //   // setShowAgreementModal(true)
      //   setIsShake(true)
      //   setTimeout(() => setIsShake(false), 400)
      //   return
      // }

      setLoading(true)

      onSubmit({
        name: values.name,
        idCard: values.idCard
      })
    } catch (error) {
      console.error('表单验证失败:', error)
    } finally {
      setLoading(false)
    }
  }

  if (!visible) {
    return null
  }

  return (
    <div className={styles.identityInfoModal}>
      <div className={styles.modalContent}>
        {/* 关闭按钮 */}
        <div className={styles.closeButton} onClick={onClose}>
          <img src={close} alt="close" width="100%" />
        </div>

        {/* 头部区域 */}
        <div className={styles.header}>
          <div className={styles.checkIcon}>
            <img src={successImg} width="100%" />
          </div>
          <div className={styles.congratulationText}>
            <div className={styles.mainText}>
              恭喜您,最高可借<span className={styles.highlight}>{maxAmount}元</span>
            </div>
            <div className={styles.subText}>最终额度以最后审批为准</div>
          </div>
        </div>

        {/* 通知轮播 */}
        <div className={styles.notificationBox}>
          <div className={styles.speakerIcon}>
            <img
              src={require('@imgs/information/sound.png')}
              alt="喇叭"
              style={{ width: '15px', height: '12px', verticalAlign: 'middle' }}
            />
          </div>
          <div className={styles.notificationContent}>
            <div className={styles.notificationText}>
              {notifications[currentNotificationIndex]?.time} {notifications[currentNotificationIndex]?.name}成功放款{notifications[currentNotificationIndex]?.amount}元
            </div>
          </div>
        </div>

        {/* 表单区域 */}
        <div className={styles.formContainer}>
          <Form
            form={form}
            layout="horizontal"
            className={styles.form}
          >
            <Form.Item
              name="name"
              label="姓名"
            >
              <Input placeholder="请输入您的姓名" onBlur={e => validateName(e.target.value)} />
            </Form.Item>

            <Form.Item
              name="idCard"
              label="身份证号"
            >
              <Input placeholder="请输入您的身份证号 (已加密)" onBlur={e => validateIdCard(e.target.value)} />
            </Form.Item>
          </Form>
        </div>
        {/* 协议勾选 */}
        {/* <div className={classNames(styles.agreement, isShake && styles.agreementShake)}>
          <i className={classNames(styles.checked, checked && styles.active)} onClick={checkedTaggle}></i>
          <span className={styles.agreementText}>
            我已阅读并同意
            <span className={styles.agreementLink} onClick={() => {
              window.location.href = '/identity-info-agreement?isShowHeader=1'
            }}>
              《身份证采集授权书》
            </span>
          </span>
        </div> */}
        {/* 提交按钮 */}
        <div className={styles.submitButtonContainer}>
          <Button
            className={styles.submitButton}
            onClick={() => handleSubmit()}
            loading={loading}
          >
            提交获取额度
          </Button>
        </div>
        {/* {showAgreementModal && (
          <div className={styles.modalOverlay}>
            <div className={styles.modalContainer} role="dialog" aria-modal="true">
              <div className={styles.modalHeader}>温馨提醒</div>
              <div className={styles.agreementModalContent}>
                <div className={styles.agreementText}>我已阅读并同意</div>
                <div className={styles.agreementLinks}>
                  <span className={styles.agreementLink} onClick={() => {
                    window.location.href = '/identity-info-agreement?isShowHeader=1'
                  }}>
                    《身份证采集授权书》
                  </span>
                </div>
              </div>
              <div className={styles.modalActions}>
                <button
                  className={styles.modalBtnConfirm}
                  onClick={() => {
                    setChecked(true)
                    setShowAgreementModal(false)
                    handleSubmit(true)
                  }}
                >
                  同意并继续
                </button>
                <button className={styles.modalBtnCancel} onClick={() => setShowAgreementModal(false)}>取消</button>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  )
}

export default IdentityInfoModal
